export function getAppScrollContainer() {
  if (typeof document === 'undefined') return null;
  return document.getElementById('app-scroll-root');
}

function scrollWithinContainer(container, targetTop) {
  container.scrollTo({
    top: Math.max(0, targetTop),
    behavior: 'auto'
  });
}

export function scrollElementToTop(element, additionalOffset = 8) {
  if (!element || typeof window === 'undefined' || typeof document === 'undefined') {
    return;
  }

  const scrollContainer = getAppScrollContainer();
  if (scrollContainer) {
    const top = scrollContainer.scrollTop
      + element.getBoundingClientRect().top
      - scrollContainer.getBoundingClientRect().top
      - additionalOffset;

    scrollWithinContainer(scrollContainer, top);
    return;
  }

  const rootStyles = window.getComputedStyle(document.documentElement);
  const topbarHeight = Number.parseInt(rootStyles.getPropertyValue('--ptcm-topbar-h'), 10) || 0;
  const top = element.getBoundingClientRect().top + window.scrollY - topbarHeight - additionalOffset;

  window.scrollTo({
    top: Math.max(0, top),
    behavior: 'auto'
  });
}

export function scrollElementBelowSticky(element, stickyElement, additionalOffset = 12) {
  if (!element || typeof window === 'undefined' || typeof document === 'undefined') {
    return;
  }

  const stickyHeight = stickyElement?.getBoundingClientRect().height || 0;
  const scrollContainer = getAppScrollContainer();
  if (scrollContainer) {
    const top = scrollContainer.scrollTop
      + element.getBoundingClientRect().top
      - scrollContainer.getBoundingClientRect().top
      - stickyHeight
      - additionalOffset;

    scrollWithinContainer(scrollContainer, top);
    return;
  }

  const rootStyles = window.getComputedStyle(document.documentElement);
  const topbarHeight = Number.parseInt(rootStyles.getPropertyValue('--ptcm-topbar-h'), 10) || 0;
  const top = element.getBoundingClientRect().top + window.scrollY - topbarHeight - stickyHeight - additionalOffset;

  window.scrollTo({
    top: Math.max(0, top),
    behavior: 'auto'
  });
}
